import React, { useContext, useMemo, useState, useEffect } from 'react';
import { Checkbox, DatePicker, Input, InputNumber } from 'antd';
import { ModelContext } from '../../metadata/ModelSource';
import { FormContext } from '../../metadata/MDForm';
import { api } from '../../../api';
const CheckboxGroup = Checkbox.Group;

export function InterestInCheckbox({ defaultValue, onChange, formAttribute }) {
  const applicationModel = useContext(ModelContext);
  const [interestInMeta, setInterestInMeta] = useState({
                                                         selectedLinkRefs: [],
                                                         availableLinkRefs: []
                                                       });
  let { setValueByAttr, getValueByAttr } = useContext(FormContext);
  useEffect(() => {
    const previousValue = getValueByAttr(formAttribute);

    const getInterests = async () => {
      return await getAccountTypes().then(res => {
        setInterestInMeta({
             selectedLinkRefs: previousValue || [],
            availableLinkRefs: res.data.linkReference || []
        });
      });
    };

    getInterests();
  }, []);

  const getAccountTypes = () => {
    const resourceId = applicationModel.data.systemId;
    return api.get(
        `/applications/${resourceId}/additionalInterests/references`
    );
  };

  const onInterestChange = selectedValues => {
    //get the risks that were selected
    let risks = interestInMeta.availableLinkRefs.filter(
        it => selectedValues.indexOf(it.idRef) >= 0
    );

    //remove risks that were deselected
    const updatedValues = interestInMeta.selectedLinkRefs.filter(it =>
        selectedValues.indexOf(it.idRef) < 0).map(it => {
          return {
              ...it,
            status: 'Deleted'
          }
    });

    risks = risks.concat(updatedValues);

    setValueByAttr(formAttribute, risks);
    setInterestInMeta({ ...interestInMeta, selectedLinkRefs: risks });
  };
  return (
      <CheckboxGroup
          style={{ marginTop: '0.75em' }}
          onChange={onInterestChange}
          value={interestInMeta.selectedLinkRefs
                               .filter(it => it.status === 'Active')
                               .map(it => it.idRef)}
      >
        {interestInMeta.availableLinkRefs.length ? interestInMeta.availableLinkRefs.map(it => (
            <Checkbox
                style={{ marginBottom: '0.5em', marginLeft: 0 }}
                value={it.idRef}
                key={it.idRef}
            >
              {it.description}
            </Checkbox>
        )) : <span>No risks available </span>}
      </CheckboxGroup>
  );
}
